import React from "react";
import { Grid, Typography } from "@mui/material";
import { RocksContainer } from "../HeroComponent";
import Rock2 from "../../assets/Rocks/rock2.svg";
import Rock4 from "../../assets/Rocks/rock4.svg";
import Rock3 from "../../assets/Rocks/rock3.svg";
import Rock5 from "../../assets/Rocks/rock5.svg";
import Rock8 from "../../assets/Rocks/rock8.svg";
import Rock9 from "../../assets/Rocks/rock9.svg";
import Journey2021 from "../../svgComponents/Journey2021";
import Journey2020 from "../../svgComponents/Journey2020";
import Journey2022 from "../../svgComponents/Journey2022";
import Journey2023 from "../../svgComponents/Journey2023";
import StoneAgeChef from "../../svgComponents/StoneAgeChef";
import PirateChef from "../../svgComponents/PirateChef";
import AlienChef from "../../svgComponents/AlienChef";
import LargeLeftSmoke from "../../svgComponents/LargeLeftSmoke";
import LargeRightSmoke from "../../svgComponents/LargeRightSmoke";
import SmallRightSmoke from "../../svgComponents/SmallRightSmoke";
import SmallLeftSmoke from "../../svgComponents/SmallLeftSmoke";

const JourneyWeb = (props) => {
  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      mt={{ xs: -10, md: -15 }}
      mb={5}
      sx={{ display: props?.display }}
    >
      <Typography variant="h2" mb={5}>
        {props.title}
      </Typography>
      <Grid container item xs={12} flexDirection="column" alignItems="center">
        <Grid
          container
          item
          sx={{
            paddingLeft: { xs: "11vw", xl: 30 },
            transform: "rotate(-2deg)",
            marginBottom: 5,
            marginTop: 5,
          }}
        >
          <Grid
            item
            sx={{
              position: "fixed",
              left: { md: 75, xl: 120 },
              top: { lg: -35, xl: -75 },
            }}
          >
            <LargeLeftSmoke
              sx={{ fontSize: { md: "48vw", lg: "50vw", xl: 800 } }}
            />
            <img
              src={Rock4}
              width="6%"
              height="auto"
              alt="rock4"
              style={{
                position: "absolute",
                left: 300,
                top: "58%",
                zIndex: 9999999,
                transform: "rotate(-15deg)",
              }}
            />
          </Grid>
          <Grid item>
            <img
              src={Rock5}
              height="auto"
              width="auto"
              alt="Rock5"
              style={{
                position: "fixed",
                left: 280,
                top: -280,
                zIndex: 9999999,
              }}
            />
            <img
              src={Rock3}
              width="2.5%"
              height="auto"
              alt="Rock3"
              style={{
                position: "absolute",
                right: "28%",
                top: -370,
                zIndex: 9999999,
              }}
            />
            <img
              src={Rock2}
              width="27vw"
              height="auto"
              alt="rock2"
              style={{
                position: "absolute",
                right: "40%",
                top: "10%",
                zIndex: 9999999,
                transform: "rotate(-10deg)",
              }}
            />
            <Journey2020
              sx={{
                fontSize: { md: "35vw", lg: "30vw", xl: 430 },
                height: "100%",
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-end"
          item
          sx={{
            paddingRight: { xs: "11vw", xl: 30 },
            transform: "rotate(2deg)",
            marginTop: -30,
          }}
        >
          <Grid
            item
            sx={{
              position: "fixed",
              right: { md: 70, xl: 150 },
              top: { md: "60vw", lg: "45vw", xl: 570 },
            }}
          >
            <LargeRightSmoke
              sx={{ fontSize: { md: "48vw", lg: "50vw", xl: 800 } }}
            />
          </Grid>
          <Grid item>
            <SmallRightSmoke
              sx={{
                fontSize: { md: 130, lg: 180 },
                marginBottom: { md: 5, lg: 0 },
              }}
            />
            <StoneAgeChef
              sx={{
                fontSize: { md: "25vw", lg: "20vw", xl: 250 },
                height: "100%",
                marginRight: { xs: "5vw", xl: 12.5 },
                marginBottom: -8,
              }}
            />
          </Grid>
          <Grid item>
            <Journey2021
              sx={{
                fontSize: { md: "35vw", lg: "30vw", xl: 430 },
                height: "100%",
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          item
          flexDirection="column"
          justifyContent="center"
          sx={{
            paddingLeft: { xs: "11vw", xl: 30 },
            transform: "rotate(-2deg)",
            marginBottom: 5,
            marginTop: -35,
          }}
        >
          <Grid
            item
            sx={{
              position: "fixed",
              left: { md: 73, xl: 150 },
              top: { md: "64vw", lg: "51vw", xl: 670 },
            }}
          >
            <LargeLeftSmoke
              sx={{ fontSize: { md: "48vw", lg: "50vw", xl: 800 } }}
            />
          </Grid>
          <Grid item>
            <PirateChef
              sx={{
                fontSize: { md: "25vw", lg: "20vw", xl: 250 },
                height: "100%",
                marginLeft: { xs: "4.5vw", xl: 10 },
                marginBottom: -8,
              }}
            />
            <SmallLeftSmoke
              sx={{
                fontSize: { md: 130, lg: 180 },
                marginLeft: { md: 1, lg: 3 },
                marginBottom: { md: 5, lg: 0 },
              }}
            />
            <img
              src={Rock9}
              height="auto"
              width="auto"
              alt="Rock8"
              style={{
                position: "absolute",
                transform: "rotate(-40deg)",
                left: "42%",
                top: 140,
                zIndex: 9999999,
              }}
            />
            <img
              src={Rock4}
              width="auto"
              height="auto"
              alt="rock4"
              style={{
                position: "absolute",
                right: "43%",
                top: 305,
                zIndex: 9999999,
                transform: "rotate(-15deg)",
              }}
            />
            <img
              src={Rock5}
              height="auto"
              width="auto"
              alt="Rock5"
              style={{
                position: "fixed",
                right: "12%",
                top: 450,
                zIndex: 9999999,
                transform: "rotate(40deg)",
              }}
            />
          </Grid>
          <Grid item>
            <Journey2022
              sx={{
                fontSize: { md: "35vw", lg: "30vw", xl: 430 },
                height: "100%",
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          item
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-end"
          sx={{
            paddingRight: { xs: "11vw", xl: 30 },
            transform: "rotate(2deg)",
            marginBottom: 5,
            marginTop: -35,
          }}
        >
          <Grid item>
            <SmallRightSmoke
              sx={{
                fontSize: { md: 130, lg: 180 },
                marginBottom: { md: 5, lg: 0 },
              }}
            />
            <AlienChef
              sx={{
                fontSize: { md: "25vw", lg: "20vw", xl: 250 },
                height: "100%",
                marginRight: { xs: "5vw", xl: 11 },
                marginBottom: -8,
              }}
            />
            <img
              src={Rock2}
              width="27vw"
              height="auto"
              alt="rock2"
              style={{
                position: "absolute",
                right: "45%",
                top: "25%",
                zIndex: 9999999,
                transform: "rotate(-160deg)",
              }}
            />
            <img
              src={Rock9}
              width="auto"
              height="9%"
              alt="rock4"
              style={{
                position: "absolute",
                left: "15%",
                top: 450,
                zIndex: 9999999,
                transform: "rotate(120deg)",
              }}
            />
          </Grid>
          <Grid item>
            <Journey2023
              sx={{
                fontSize: { md: "35vw", lg: "30vw", xl: 430 },
                height: "100%",
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <RocksContainer>
        <img
          src={Rock9}
          width="5%"
          height="auto"
          alt="Rock9"
          style={{
            position: "absolute",
            right: "25%",
            top: 180,
            zIndex: 9999999,
          }}
        />
        <img
          src={Rock8}
          height="auto"
          width="auto"
          alt="Rock8"
          style={{
            position: "absolute",
            left: "30%",
            top: 50,
            zIndex: 9999999,
          }}
        />
      </RocksContainer>
    </Grid>
  );
};
export default JourneyWeb;
